const setBreadcrumb = (state) => state.breadcrumb
const getContentFile = (state) => state.fileContent
const getNavbarChild = (state) => state.navbarChild
export default {
    setBreadcrumb,
    getContentFile,
    getNavbarChild
}